import {Component, OnDestroy, OnInit} from '@angular/core';
import {SharedService} from '@ems/shared';
import {entitlementConst} from '@shell_components/constants/entitlementConstants';
import {ShellConstant} from '@shell_components/constants/shellConstants';
import {Router} from '@angular/router';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html'
})
export class ReportsComponent implements OnInit, OnDestroy {

  reportsSubMenu: any;
  entitlementConst = entitlementConst;
  shellConstant = ShellConstant;
  clientInfo: any;
  isReportsComponent = true;

  constructor(public sharedService: SharedService, public router: Router) {
    /* Navigate to respective page based on the selected client access */
    this.sharedService.selectedClientInfo.subscribe(clientInfo => {
      this.clientInfo = clientInfo;
      if (this.isReportsComponent) {
        this.setNavigation();
      }
    });
  }

  ngOnInit() {
    this.setNavigation();
  }

  setNavigation() {
    const emtrEntitlement = entitlementConst.navUUID.emtrAccess.emtrAppAccess.uuid;
    const addlinkEntitlement = entitlementConst.navUUID.addLinkAccess.uuid;
    this.reportsSubMenu = [
      {
        id: 1,
        name: 'Reports',
        route: 'reports-list',
        showLink: this.sharedService.checkEntitlements(emtrEntitlement, addlinkEntitlement, '')
      },
      {
        id: 2,
        name: 'Preset Reports',
        route: 'preset-reports',
        showLink: this.sharedService.checkEntitlements(emtrEntitlement, addlinkEntitlement, '')
      },
    ];

    /* If client is selected and the selected client does not have access to Rule Agent and Auth Agent access, then navigate to Admin menu */
    if (this.clientInfo && !this.sharedService.checkEntitlements(entitlementConst.navUUID.emtrAccess.ruleSummary.uuid, entitlementConst.navUUID.accountSummary.uuid, '')) {
      this.sharedService.loadDataTrackValue('client_redirect');
      this.isReportsComponent = false;
      if (this.sharedService.checkEntitlements(entitlementConst.navUUID.emtrAccess.instrumentsSummary.uuid, '', '')) {
        this.router.navigate(['/ems/emtr/instrument-groups/instrument-group-list']);
      } else {
        this.router.navigate(['ems/admin/manage-clients']);
      }
    }
  }

  ngOnDestroy(): void {
    this.isReportsComponent = false;
  }
}
